import { ProjectFromAPI } from '../types';
import { transformProjects } from './api-transforms';
import apiRequest from './apiRequest';

export default async function getProjects(
  limit?: number,
  nextToken?: string,
  bookmarksOnly?: boolean,
) {
  const urlParams = new URLSearchParams();
  if (limit) {
    urlParams.set('limit', limit.toString());
  }
  if (nextToken) {
    urlParams.set('nextToken', nextToken);
  }
  if (bookmarksOnly) {
    urlParams.set('bookmarksOnly', 'true');
  }
  const { data, error } = await apiRequest<{
    projects: ProjectFromAPI[];
    nextToken?: string;
  }>(
    'mogen-orchestration',
    `/v2/projects${urlParams.toString() ? '?' + urlParams.toString() : ''}`,
  );

  return {
    data: transformProjects(data?.projects),
    nextToken: data?.nextToken,
    error,
  };
}
